<template>
<svg viewBox="0 0 32 32" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Vertical`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 7C15 6.44772 14.5523 6 14 6C13.4477 6 13 6.44772 13 7V13H7C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H14C14.5523 15 15 14.5523 15 14V7ZM25 19C25.5523 19 26 18.5523 26 18C26 17.4477 25.5523 17 25 17H18C17.4477 17 17 17.4477 17 18V25C17 25.5523 17.4477 26 18 26C18.5523 26 19 25.5523 19 25V19H25Z"/></svg>
</template>
<script>

export default {
  name: 'IconVertical',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
